export const getIconKey = (service) => {
    let serviceName = service.split('/')
    serviceName = serviceName?.length > 0 ? serviceName[0] : service
    return serviceName
}

export const stepLables = {
    edit: ["Edit Provision Details", "Edit Service Details"],
    clone: ["Provision Details(Clone)", "Service Details(Clone)"]
}

export const stateModel = {
    accountNumber: null,
    region: "",
    service: "",
    name: "",
    description: "",
}

export const serviceDescriptions = {
    "alb": "Route traffic among backend services using advanced routing and load balancing",
    "dynamodb/autoscaling": "Automatically adjust read and write capacity for DynamoDB tables based on traffic",
    "dynamodb/basic": "Fully managed NoSQL database for low-latency access at any scale",
    "ebs": "Block storage volumes for EC2 instances with independent lifecycle persistence",
    "ec2_instance": "Scalable compute capacity in the cloud",
    "ecr": "Store, manage, and deploy Docker container images",
    "efs": "Scalable file storage for EC2 instances",
    "eks": "Managed Kubernetes service for containerized applications",
    "kms": "Create and control encryption keys",
    "rds/mysql": "Managed MySQL database service",
    "rds/postgres": "Managed PostgreSQL database service",
    "redis": "Managed Redis service for in-memory data storage",
    "s3": "Scalable object storage",
    "secretmanager": "Manage, retrieve, and rotate secrets",
    "sg": "Virtual firewalls for controlling traffic",
    "sns": "Pub/sub messaging service for notifications",
    "sqs": "Managed message queuing service",
    "ssm": "Manage AWS resources securely",
    "vpc": "Virtual network for AWS resources",
    "iam-role": "Configure IAM roles for secure access and permissions management",
    "aurora/mysql": "Deploy Aurora database clusters for scalable and high-performance relational databases",
    "aurora/postgresql": "Deploy Aurora database clusters for scalable and high-performance relational databases",
    "redshift": "Utilize Redshift for data warehousing solutions with robust analytics capabilities",
    "asg": "Implement Auto Scaling Groups to dynamically adjust compute capacity based on demand"
}